import { FunctionComponent } from 'preact';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { usePlayerAirplay } from '../../hooks/usePlayerAirplay';
import { useIcons } from '../../hooks/useIcons';

export const AirPlayButton: FunctionComponent<IconButtonProps> = (props) => {
  const { displayAirplay, handleAirplay } = usePlayerAirplay();
  const { AirplayVideo } = useIcons();

  if (!displayAirplay) {
    return null;
  }

  return (
    <IconButton onClick={handleAirplay} {...props}>
      <AirplayVideo />
    </IconButton>
  );
};
